import {message} from '@sail/intl';
import type {ConnectElementConfig} from '../ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

const messages = {
  errorText: message({
    id: 'connectEmbed.payoutReconciliationReport.errorBoundary.text',
    defaultMessage: 'Your payout reconciliation report cannot be loaded.',
    description: 'Message shown when an unhandled report error is caught',
  }),
};

export const PayoutReconciliationReportConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "payoutReconciliationReport" */ '../../../components/Reporting/PayoutReconciliationReport/PayoutReconciliationReport'
    ),
  htmlEvents: ['onreportavailabilityloaded'],
  customHtmlElementMethods: {
    setOnReportAvailabilityLoaded: {
      type: 'EventListenerMethod',
      event: 'onreportavailabilityloaded',
      isInternal: false,
      description:
        'Sets the event listener that allows a user to pass in a callback function for when the report is available',
    },
  },
  messageOverrides: messages,
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/payout-reconciliation-report',
  },
  docSitePath:
    '/connect/supported-embedded-components/payout-reconciliation-report',
  releaseState: 'ga',
  enabledOverrideFlag: ComponentOverrideFlag.payout_reconciliation_report,
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description:
    'Displays the payout reconciliation report for a connected account.',
  friendlyName: 'Payout reconciliation report',
};
